<h1 class="sr-only"><span>REMANENTES SORTEO ANÁHUAC MAGNO 2026</span></h1>
<section id="remanentes" class="banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">

            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">Destino</span></span>
                    <h2 class="main-text">de fondos</h2>
                </div>
            </div>
            
        </div>
    </div>
</section>

<section class="stc-person">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center" data-aos="fade-down" data-aos-easing="ease" data-aos-duration="3000">
                <h2>
                    Las Universidades han destinado parte
                    <span class="d-block">de sus remanentes a diferentes proyectos:</span>
                </h2>
                <div class="container-img">
                    <img src="/assets/images/sorteo2025/slide-remanente.png">
                </div>
                <p>
                    Gracias a tu apoyo, los recursos que se obtienen del Sorteo
                    Anáhuac se destinan al Programa de Becas, infraestructura
                    académica, deportiva y vial de la Universidad Anáhuac.
                </p>
            </div>
        </div>
    </div>
</section>



<section class="box-remanente">
    <div class="container">
        
        <div class="capsula-remanente">
            <div class="capsula-img">
                <img src="/assets/images/sorteo2025/remanente1.jpg">
            </div>
            <div class="capsula-content">
                <h3>PROGRAMA DE BECAS</h3>
                <p class="desc">LAS UNIVERSIDADES QUE HAN DESTINADO PARTE DE SUS REMANENTES AL PROGRAMA DE BECAS SON:</p>
                <div class="lista-unis">
                    <p>Universidad Anáhuac Querétaro.</p>
                    <p>Universidad Anáhuac Mayab.</p>
                    <p>Universidad Anáhuac México Norte.</p>
                    <p>Universidad Anáhuac México Sur.</p>
                </div>
            </div>
        </div>

        <div class="capsula-remanente">
            <div class="capsula-img">
                <img src="/assets/images/sorteo2025/remanente2.jpg">
            </div>
            <div class="capsula-content">
                <h3>INFRAESTRUCTURA DEPORTIVA Y VIAL</h3>
                <p class="desc">LAS UNIVERSIDADES QUE HAN SIDO BENEFICIADAS EN PROYECTOS DEPORTIVOS CON EL SORTEO ANÁHUAC SON:</p>
                <div class="lista-unis">
                    <p>Universidad Anáhuac Mayab</p>
                    <p>Universidad Anáhuac Puebla</p>
                    <p>Universidad Anáhuac México Norte</p>
                </div>
            </div>
        </div>

        <div class="capsula-remanente">
            <div class="capsula-img">
                <img src="/assets/images/sorteo2025/remanente3.jpg">
            </div>
            <div class="capsula-content">
                <h3>INFRAESTRUCTURA ACADÉMICA</h3>
                <p class="desc">LAS UNIVERSIDADES QUE HAN SIDO BENEFICIADAS EN INFRAESTRUCTURA ACADÉMICA CON EL SORTEO ANÁHUAC SON:</p>
                <div class="lista-unis">
                    <p>Instituto de Estudios Superiores de Tamaulipas.</p>
                    <p>Universidad Anáhuac Oaxaca.</p>
                    <p>Universidad Anáhuac Querétaro.</p>
                </div>
            </div>
        </div>

    </div>
</section>


<section class="remanente-text">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h5>
                    CONSOLIDACIÓN ACADÉMICA
                </h5>
                <p>
                    El Pontificio Instituto Juan Pablo II ha decidido invertir
                    sus remanentes del Sorteo Anáhuac en la educación y
                    equipamiento de las aulas en sus sedes de Guadalajara y
                    Monterrey.
                </p>
            </div>
        </div>
    </div>
</section>